import { Component } from 'react';
import { CIP_LOGIN_URL } from './app-constants';
import { isRedirectedAfterLogin, generateRandomString, getEventRouteAndUserHashDetails } from './app-actions';

class AppCIPRedirect extends Component {
  componentDidMount() {
    const eventRouteDetails = getEventRouteAndUserHashDetails();
    const locationHash = window.location.hash;
    if (eventRouteDetails.isEventRouteAndUserHashPresent
      || eventRouteDetails.isHostedRoutePresent
      || eventRouteDetails.isBusinessPopMailRoutePresent
      || eventRouteDetails.isAdaptiveMobilityExternalPresent) {
      sessionStorage.setItem('eventUserIdHashValue', eventRouteDetails.useridHashValue);
    } else if (!isRedirectedAfterLogin(locationHash) && eventRouteDetails.isPartnerView === false) {
      window.location = CIP_LOGIN_URL + generateRandomString(9); // appending a unique string for nonce each time;
    }
  }
  render() {
    return this.props.children;
  }
}

export default AppCIPRedirect;
